var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelOfNames(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44,5.66a.9.9,0,1,0,.9.9A.9.9,0,0,0,7.44,5.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41,9.19a.9.9,0,1,0,.9.9A.9.9,0,0,0,9.41,9.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22,17l-.6-4.15A3.85,3.85,0,0,0,17,9.61L14.15,10l.56-2A3.84,3.84,0,0,0,12.07,3.3L8,2.15A3.84,3.84,0,0,0,3.29,4.8l-1.15,4a3.87,3.87,0,0,0,2.65,4.75l4,1.14a4.63,4.63,0,0,0,.83.13l.55,3.86A3.86,3.86,0,0,0,14,22a3.39,3.39,0,0,0,.55,0l4.16-.6A3.85,3.85,0,0,0,22,17Zm-11.63-5.3a3.87,3.87,0,0,0-.54,1,1.27,1.27,0,0,1-.39,0l-4-1.14a1.76,1.76,0,0,1-1.06-.83A1.79,1.79,0,0,1,4.15,9.4l1.14-4A1.75,1.75,0,0,1,7.46,4.16l4,1.14a1.76,1.76,0,0,1,1.21,2.17l-.86,3.05A3.76,3.76,0,0,0,10.33,11.71Zm8.08,7.59-4.15.6a1.75,1.75,0,0,1-2-1.49l-.6-4.15a1.75,1.75,0,0,1,1.48-2l4.16-.6a1.75,1.75,0,0,1,2,1.48l.61,4.16A1.77,1.77,0,0,1,18.41,19.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.11,16.12a.9.9,0,1,0-.9.9A.9.9,0,0,0,15.11,16.12Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.91,
    cy: 14.05,
    r: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.51,
    cy: 18.19,
    r: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.35,
    cy: 15.66,
    r: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18,13.6a.9.9,0,0,0-1.8,0,.9.9,0,0,0,1.8,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.65,16.83a.9.9,0,1,0,.9.9A.9.9,0,0,0,17.65,16.83Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelOfNames);
export default __webpack_public_path__ + "static/media/wheel-of-names.a549be6fe1c7d176ce98824958ea846a.svg";
export { ForwardRef as ReactComponent };